import { Modal, Divider, Radio, Button } from 'antd';
import { InfoCircleOutlined, RightOutlined } from '@ant-design/icons';
import { getCondition } from '@/api/hdd/leftPanel';
import { resetRender } from '@/api/hdd/album';
import { useStoreState } from '&/utils/customHooks';
import { getUserInfo } from '@/api/Dialogs/signUpDlg';
import './UpgradeModal.scss';
import { useEffect } from 'react';
const UpgradeModal = props => {
    const appStore = useStoreState('appStore');

    const { isModalOpen, setIsModalOpen } = props;

    const [resolution, setResolution] = useState({});

    const [resolutionList, setResolutionList] = useState([]);

    const [loading, setLoading] = useState(false);

    const handleOk = () => {
        setLoading(true);
        resetRender({ renderId: props.id, resolution: resolution })
            .then(res => {
                console.log('res', res);
                props.getCurList();
                setLoading(false);
                setIsModalOpen(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const onChange = e => {
        console.log(e.target.value);
        setResolution(e.target.value);
        // setResolution(resolutionList.find(v => v.id === e.target.value))
    };

    useEffect(() => {
        if (!isModalOpen) return;
        getCondition({ renderType: props.itemType === 'album' ? 0 : 1 }).then(
            res => {
                console.log('res', res);
                console.log('props', props);
                setResolutionList(res.data.resolution);
            }
        );
    }, [isModalOpen, props.itemType]);

    const getResolution = () => {
        return resolutionList.find(v => v.value === resolution);
    };

    const openBuyCouponsModal = async e => {
        e.stopPropagation();
        try {
            const res = await getUserInfo();
            let sendData = {};
            const urlParams = `?token=${appStore?.token}`;
            if (res.data.type === 1) {
                const url = `${window.location.origin}/hdd/renderingCouponsList`;
                sendData = {
                    Url: `${url}${urlParams}`,
                    Width: 900,
                    Height: 634,
                };
            } else {
                const url = `${window.location.origin}/hdd/consultQRCodeModal`;
                sendData = {
                    Url: `${url}${urlParams}`,
                    Width: 360,
                    Height: 400,
                };
            }
            setIsModalOpen(false);
            window.external.DispatchFun(
                'Atlas',
                'Render',
                JSON.stringify(sendData)
            );
        } catch (e) {}
    };

    return (
        <>
            <Modal
                title="升级分辨率"
                okText="立即升级"
                destroyOnClose
                visible={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                okButtonProps={{
                    type: 'default',
                    loading,
                    disabled: Object.keys(resolution).length === 0,
                }}
                wrapClassName="upgradeModal">
                <div className="tip">
                    <InfoCircleOutlined /> 升级后，原图将被替换且不可恢复
                </div>
                <div className="content-coupon">
                    <span className="word">清晰度</span>
                    <Divider type="vertical" />
                    已选
                    {getResolution()
                        ? getResolution()?.value +
                          getResolution()?.resolutionName
                        : ''}
                    &nbsp;剩余渲染券
                    <span className="number">
                        {' '}
                        {getResolution()?.rest === 'all'
                            ? '无限'
                            : getResolution()?.rest}
                    </span>
                    <Button type="link" onClick={openBuyCouponsModal}>
                        去购买
                        <RightOutlined />
                    </Button>
                </div>

                <div>
                    <Radio.Group
                        size="large"
                        onChange={onChange}
                        value={resolution}>
                        {resolutionList.map(v => (
                            <Radio.Button
                                value={v.value}
                                disabled={
                                    v.value?.slice(0, -1) <=
                                    props.resolution?.slice(0, -1)
                                }
                                key={v.value}>
                                <span className="name">
                                    {v.value + v.resolutionName}
                                </span>
                                <br />
                                <span className="pixel">
                                    {v.resolutionW + '*' + v.resolutionH}
                                </span>
                            </Radio.Button>
                        ))}
                    </Radio.Group>
                </div>
            </Modal>
        </>
    );
};

export default UpgradeModal;
